query LayoutAgents($companyId: ID!) {
  company(id: $companyId) {
    agentRegistrations {
      id
      databaseId
      name
      status
      lastHeartbeatAt
    }
  }
}
